import { useRef, useState, useMemo, useCallback, PropsWithChildren } from 'react';
import { ValidationType } from '../utils/ValidationType';
import { HeaderContext, HeaderContextType, HeaderTitle } from './HeaderContext';

export const HeaderProvider = ({ children }: PropsWithChildren) => {
  const submitRef = useRef<((type: ValidationType) => void) | null>(null);
  const [isFormLoading, setIsFormLoading] = useState(false);
  const [headerTitle, setHeaderTitle] = useState<HeaderTitle | undefined>(undefined);
  const [formProgress, setFormProgress] = useState<number>(0);
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);

  const setSubmit = useCallback((submit: (type: ValidationType) => void) => {
    submitRef.current = submit;
  }, []);

  const triggerSubmit = useCallback((type: ValidationType) => {
    if (submitRef.current) {
      submitRef.current(type);
    }
  }, []);

  const value = useMemo<HeaderContextType>(
    () => ({
      headerTitle,
      setHeaderTitle,
      triggerSubmit,
      setSubmit,
      isFormLoading,
      setIsFormLoading,
      formProgress,
      setFormProgress,
      isFormSubmitted,
      setIsFormSubmitted,
    }),
    [headerTitle, isFormLoading, formProgress, isFormSubmitted, setSubmit, triggerSubmit],
  );

  return <HeaderContext.Provider value={value}>{children}</HeaderContext.Provider>;
};
